import { render, staticRenderFns } from "./SertifikatIcon.vue?vue&type=template&id=5f881edb"
import script from "./SertifikatIcon.vue?vue&type=script&lang=js"
export * from "./SertifikatIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports